<div class="row widgetContainer" [ngClass]="widgets && widgets.length ? 'hasWidgets' : ''"
  (click)="refresh($event)">
  @for (widget of widgets; track widget; let widgetIndex = $index) {
    <app-widget [widget]="widget" class="d-flex col-3"></app-widget>
  }
</div>
<ng-container>
  @if (!loaded) {
    <ngx-skeleton-loader class="d-flex flex-wrap w-100" count="4" appearance="line"
      [theme]="{height: '200px', width: '24%', margin: '0.5%' }">
    </ngx-skeleton-loader>
  }
</ng-container>
